import {Component, inject, Input, OnInit} from '@angular/core';
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {DecimalPipe, NgIf} from "@angular/common";
import {ConsiderDocument, ReportOnOffBoardResultDto, Sex} from "../../../../../generated-model/model";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {FormsModule} from "@angular/forms";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {ImageViewerComponent} from "../../../../shared/commons/image-viewer/image-viewer.component";
import {PdfDialogComponent} from "../../../../shared/commons/pdf-dialog/pdf-dialog.component";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {ConsiderDocumentResource} from "../../../../service/ConsiderDocumentResource";

@Component({
  selector: 'app-enroll-modal',
  templateUrl: './uc-register-history-modal.component.html',
  styleUrls: ['./uc-register-history-modal.component.css'],
  imports: [
    NgIf,
    SharedCommonModule,
    FormsModule,
    DecimalPipe,
    NotFoundComponent
  ],
  standalone: true
})
export class UcRegisterHistoryModalComponent implements OnInit {
  @Input() item: ReportOnOffBoardResultDto = {};
  sexDesc = Sex;
  private http = inject(HttpClient);
  private modalService = inject(NgbModal);
  private considerDocumentResource = inject(ConsiderDocumentResource);
  documents: any;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    if (this.item.transId) {
      this.http.get(`${environment.serverUrl}/api/erm-reg-main/documents/` + this.item.transId)
        .subscribe(d => {
          this.documents = d
        });
    }
  }

  close() {
    this.activeModal.close(false);
  }

  select() {
    this.activeModal.close(true);
  }

  isImage(mime: string): boolean {
    return mime?.toLowerCase().startsWith("image")
  }

  isPdf(mime: string): boolean {
    return mime?.toLowerCase().includes("pdf")
  }

  showImage(file: ConsiderDocument) {
    this.considerDocumentResource.objectUrl(file, 'image').subscribe(url => {
      let modalRef = this.modalService.open(ImageViewerComponent, {size: 'xl', scrollable: true, centered: true});
      let componentInstance = modalRef.componentInstance as ImageViewerComponent;
      componentInstance.src = url;
      modalRef.hidden.subscribe(() => URL.revokeObjectURL(url));
    });
  }

  showDoc(file: ConsiderDocument) {
    this.considerDocumentResource.objectUrl(file, 'pdf').subscribe(url => {
      let modalRef = this.modalService.open(PdfDialogComponent, {size: 'xl', scrollable: true, centered: true});
      let componentInstance = modalRef.componentInstance as PdfDialogComponent;
      componentInstance.url = url;
      modalRef.hidden.subscribe(() => URL.revokeObjectURL(url));
    });
  }

  downloadDoc(file: ConsiderDocument) {
    this.considerDocumentResource.downloadDoc(file)
  }
}
